import { Group, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconArrowsJoin2, IconBriefcase, IconBuildingFactory, IconHandStop, IconRocket, IconTransfer } from "@tabler/icons-react";
import { getCollaborationIntentLabel } from "@/components/shared/constants/general.const";
import type { SectorEcosystemOverview } from "../../../../../../shared/sectorEcosystemOverview";
import SectorDashboardCard from "./SectorDashboardCard";

const INTENT_ICONS: Record<string, typeof IconBriefcase> = {
  STRATEGIC_JOINT_VENTURE: IconRocket,
  TECHNOLOGY_LICENSING: IconTransfer,
  MANUFACTURING: IconBuildingFactory,
  DISTRIBUTION_MARKET_ACCESS: IconHandStop,
  RD_CO_DEVELOPMENT: IconArrowsJoin2,
  OUTSOURCING_MANAGED_SERVICES_API_SOFTWARE_INTEGRATION: IconBriefcase,
};

type SectorCollaborationModelsCardProps = {
  overview: SectorEcosystemOverview;
};

export default function SectorCollaborationModelsCard({ overview }: SectorCollaborationModelsCardProps) {
  return (
    <SectorDashboardCard
      title="Collaboration Models"
      subtitle="How companies want to work together."
    >
      <Stack gap="xs">
        {overview.collaborationModels.length === 0 ? (
          <Text size="sm" c="dimmed">
            No collaboration models listed yet.
          </Text>
        ) : (
          overview.collaborationModels.map((row) => {
            const Icon = INTENT_ICONS[row.intent] ?? IconBriefcase;
            return (
              <Group key={row.intent} gap="xs" wrap="nowrap">
                <ThemeIcon size={24} radius="md" variant="light" color="gray">
                  <Icon size={12} />
                </ThemeIcon>
                <Text size="sm">
                  {getCollaborationIntentLabel(row.intent)}
                </Text>
              </Group>
            );
          })
        )}
      </Stack>
    </SectorDashboardCard>
  );
}
